export default {
  getHijackMonitorInfoPage: {
    method: 'post',
    url: '/hijack/getHijackMonitorInfoPage',
    desc: '商品跟卖列表-分页'
  },
  getHijackGoodsDetailInfoList: {
    method: 'post',
    url: '/hijack/getHijackGoodsDetailInfoList',
    desc: '商品跟卖详情'
  },
  getHistoryHijackGoodsDetailInfoList: {
    method: 'post',
    url: '/hijack/getHistoryHijackGoodsDetailInfoList',
    desc: '店铺跟卖历史详情'
  },
  getShopWhiteList: {
    method: 'post',
    url: '/hijack/getShopWhiteList',
    desc: '获取白名单'
  },
  registerShopWhiteList: {
    method: 'post',
    url: '/hijack/registerShopWhiteList',
    desc: '注册白名单'
  },
  getSellerList: {
    method: 'post',
    url: '/hijack/getSellerList',
    desc: '跟卖商品的所有店铺'
  },
  addMonitor: {
    method: 'post',
    url: '/hijack/addMonitor',
    desc: '新增商品监控'
  },
  deleteMonitor: {
    method: 'post',
    url: '/hijack/deleteMonitor',
    desc: '删除商品监控'
  },
  getAllGoodsInfo: {
    method: 'post',
    url: '/hijack/getAllGoodsInfo',
    desc: '新增商品监控-获取所有商品'
  }
}
